module.exports = __webpack_public_path__ + "static/media/logo-bitcoin.4fd2e1b8.svg";